(() => {
  document.querySelectorAll('.sf-release-notifications').forEach(details => {
    if (details.querySelector('[data-signup-result]')) details.open = true;
  });
  if (customElements.get('sf-release-summary')) return;
  customElements.define('sf-release-summary', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.initial = {
        releaseAt: Number(this.dataset.releaseAt) || 0,
        serverNow: Number(this.dataset.serverNow) || 0
      };
      this.startedAt = performance.now();
      this.upcoming = this.querySelector('[data-release-upcoming]');
      this.pending = this.querySelector('[data-release-pending]');
      this.date = this.querySelector('[data-release-date]');
      this.digits = this.querySelectorAll('[data-time-unit]');
      this.status = this.querySelector('[data-count-status]');
      this.render();
      this.timer = setInterval(() => this.render(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    render() {
      const lock = document.querySelector('sf-live-lock');
      const state = lock?.state || this.initial;
      const now = typeof lock?.now === 'function'
        ? lock.now()
        : this.initial.serverNow * 1000 + performance.now() - this.startedAt;
      const releaseAt = Number(state.releaseAt) || 0;
      const remaining = Math.max(0, Math.ceil((releaseAt * 1000 - now) / 1000));
      const scheduled = releaseAt > 0 && remaining > 0;
      this.hidden = !scheduled;
      if (this.upcoming) this.upcoming.hidden = !scheduled;
      if (this.pending) this.pending.hidden = scheduled;
      if (!scheduled) {
        if (this.status) this.status.textContent = '';
        this.lastAnnouncement = null;
        return;
      }
      if (this.target !== releaseAt) {
        this.target = releaseAt;
        const releaseDate = new Date(releaseAt * 1000);
        this.date.dateTime = releaseDate.toISOString();
        this.date.textContent = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/London', day: '2-digit', month: 'long', year: 'numeric',
          hour: '2-digit', minute: '2-digit', hourCycle: 'h23', timeZoneName: 'short'
        }).format(releaseDate);
      }
      const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
      this.digits.forEach((digit, i) => { digit.textContent = String(values[i]).padStart(2, '0'); });
      const announcement = `${releaseAt}:${Math.ceil(remaining / 60)}`;
      if (this.status && announcement !== this.lastAnnouncement) {
        this.status.textContent = `${this.date.textContent}. ${values[0]} days, ${values[1]} hours and ${values[2]} minutes until release.`;
        this.lastAnnouncement = announcement;
      }
    }
  });
})();